import React from 'react'
import { Link } from 'react-router-dom'

const Breadcrumb = ({ title }) =>
  title && (
    <nav className="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <Link to={`portals`}>Home</Link>
        </li>
        <li className="is-active">
          <a>{title}</a>
        </li>
      </ul>
    </nav>
  )

export default Breadcrumb



// WEBPACK FOOTER //
// ./src/components/templates/navigation/Breadcrumb.js